import React from "react"

interface ProductColorProps {
  sku: any
  onClick: (sku: any) => void
  size: number
}

export const ProductColor: React.FC<ProductColorProps> = ({ sku, onClick, size }) => {
  let color = ""
  if (sku.vto.color.includes("#")) {
    color = sku.vto.color
  } else {
    const colorValue = sku.vto.color
      .split(" ")
      .map((color: string) => parseFloat(color) * 255)
      .join(", ") as string
    color = `rgb(${colorValue})`
  }

  return (
    <span
      style={{
        backgroundColor: color,
        width: size,
        height: size,
        borderRadius: size,
      }}
      onClick={() => (onClick ? onClick(sku) : null)}
    />
  )
}
